import { FC, PropsWithChildren } from 'react';

import Text from 'bloko/blocks/text';
import VSpacing from 'bloko/blocks/vSpacing';

import { useRequestCancel } from 'hooks/common/useRequestCancel';
import useTrls from 'hooks/translation/useTrls';

import InputWithDatePicker from 'components/Admin/Reports/ActsReport/Filter/InputWithDatePicker';
import ActsSummaryInfo from 'components/Admin/Reports/ActsSummaryReport/ActsSummaryInfo';
import { fetchActsSummaryReport } from 'components/Admin/Reports/ActsSummaryReport/fetchActsSummaryReport';
import { fetchActsSummaryReportCSV } from 'components/Admin/Reports/ActsSummaryReport/fetchActsSummaryReportCSV';
import { SelectActiveCurrency } from 'components/Admin/Reports/ActsSummaryReport/SelectActiveCurrency/SelectActiveCurrency';
import ReportWrapper from 'components/Admin/Reports/ReportWrapper';

import { useDispatch, useSelector } from 'store/utils';

import 'components/Admin/Reports/ActsSummaryReport/ActsSummaryReport.less';

const ActsSummaryReport: FC<PropsWithChildren> = () => {
    const { actsSummary, isLoad, isCSVLoad } = useSelector((state) => state.actsSummary);

    const dispatch = useDispatch();
    const { abortRequest, abortSignal } = useRequestCancel();
    const trl = useTrls();

    const onClickCSV = () => {
        abortRequest();
        void dispatch(fetchActsSummaryReportCSV(abortSignal()));
    };

    const onClickSearch = () => {
        abortRequest();
        void dispatch(fetchActsSummaryReport(abortSignal()));
    };

    return (
        <ReportWrapper
            title={trl('Admin.Reports.ActsSummaryReport.title')}
            filter={
                <>
                    <InputWithDatePicker />
                    <SelectActiveCurrency />
                </>
            }
            content={
                <div className="acts-summary-report-content">
                    {actsSummary && (
                        <>
                            <div className="acts-summary-report-total">
                                <Text strong>{trl('Admin.Reports.ActsSummaryReport.titleTotal.auto')}</Text>
                                <VSpacing base={2} />
                                <ActsSummaryInfo data={actsSummary?.auto} />
                            </div>
                            <div className="acts-summary-report-total">
                                <Text strong>{trl('Admin.Reports.ActsSummaryReport.titleTotal.manual')}</Text>
                                <VSpacing base={2} />
                                <ActsSummaryInfo data={actsSummary?.manual} />
                            </div>
                        </>
                    )}
                </div>
            }
            isLoadContent={isLoad || isCSVLoad}
            onClickSearch={onClickSearch}
            onClickCSV={onClickCSV}
        />
    );
};

export default ActsSummaryReport;
